import { useEffect, useState } from "react";
import { Graph } from "../components/Graph";

import type { Message, ActivityStats } from "@mythic/coms/types";

import "./Tracker.css";
import TitleBar from "../components/TitleBar/TitleBar";

export default function Tracker() {
    const [range, setRange] = useState<
        "month" | "quarter" | "year" | "alltime"
    >("quarter");

    const [monthly, setMonthly] = useState<ActivityStats[]>([]);
    const [quarterly, setQuarterly] = useState<ActivityStats[]>([]);
    const [yearly, setYearly] = useState<ActivityStats[]>([]);
    const [allTime, setAllTime] = useState<ActivityStats[]>([]);

    useEffect(() => {
        const fetchAddr = `${import.meta.env.VITE_SERVER_URL}/api/activityfeed/getstats`;
        console.log("Fetching:", fetchAddr);
        fetch(fetchAddr)
            .then((response) => {
                return response.json();
            })
            .then((json: Message) => {
                if (json.target !== "activityfeed") return;
                if (json.action !== "stats") return;

                setMonthly(json.stats.month);
                setQuarterly(json.stats.quarter);
                setYearly(json.stats.year);
                setAllTime(json.stats.allTime);
                console.log("Set stats:", json);
            });
    }, []);

    return (
        <>
            <TitleBar title="Mythic Redeems" />
            <div
                style={{
                    flexGrow: 1,
                    display: "flex",
                    width: "90vw",
                    maxWidth: "1024px",
                    flexDirection: "column",
                }}
            >
                <div className="tab-bar">
                    <button
                        className={`tab-button ${range === "month" ? "active" : ""}`}
                        onClick={() => setRange("month")}
                    >
                        Month
                    </button>
                    <button
                        className={`tab-button ${range === "quarter" ? "active" : ""}`}
                        onClick={() => setRange("quarter")}
                    >
                        Quarter
                    </button>
                    <button
                        className={`tab-button ${range === "year" ? "active" : ""}`}
                        onClick={() => setRange("year")}
                    >
                        Year
                    </button>
                    <button
                        className={`tab-button ${range === "alltime" ? "active" : ""}`}
                        onClick={() => setRange("alltime")}
                    >
                        All Time
                    </button>
                </div>
                <div className="graph-view">
                    <Graph
                        data={
                            range === "month"
                                ? monthly
                                : range === "quarter"
                                  ? quarterly
                                  : range === "year"
                                    ? yearly
                                    : allTime
                        }
                    />
                </div>
            </div>
        </>
    );
}
